/**
 * Make payload API friendly
 * @param {*} data
 * @returns denormalised api friendly payload
 */
export function denormaliseMobilePaymentForm(formPayload) {
  let payload = {
    first_name: formPayload.name.value,
    addressee: formPayload.name.value,
    // If apartment is provided, add it to the address_1 field to be consistent with the shipbob address format
    address_1: formPayload.apartment.value
      ? `${formPayload.apartment.value} - ${formPayload.address.value}`
      : formPayload.address.value,
    city: formPayload.locality.value,
    post_code: formPayload.postal.value,
    stateId: formPayload.stateId.value,
    countryId: formPayload.countryId.value,
    delivery_method_id: formPayload.deliveryMethod.value,
    no_headset_required: formPayload.headsetType.value === "none" ? 1 : 0,
    voucher_code: formPayload.voucher.value,
    user_id: formPayload.user_id.value,
    token: formPayload.headset_purchase_token.value,
    phone: formPayload.phoneNumber.value,
  };

  return payload;
}
